<script>
	// Раздел Documents - отдельное окно, полностью переиспользующее компонент раздела Files (File.vue),
	// но работающее в режиме защищённого раздела: у него своя папка хранилища (Documents),
	// доступ только для супер-админов и обязательный ввод ключа шифрования при открытии.
	// Отдельное имя компонента нужно, чтобы окно открывалось своим событием Broadcast "Show Documents",
	// а не вместе с обычным файловым менеджером ("Show File").
	import FileManager from './File.vue';

	export default {
		...FileManager,
		name: 'Documents',
		props: {
			section: {type: String, default: 'documents'}
		}
	};
</script>
